// extracted by mini-css-extract-plugin
export default {"mainContainer":"loadingCommentsComponent_mainContainer__++SVH"};